// src/pages/Contact.js
import React, { useState } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import {
  Box,
  Typography,
  TextField,
  Button,
  Paper,
} from '@mui/material';
import { useLocation } from 'react-router-dom';

import NavBar from '../components/NavBar';
import theme from '../theme';

function useQuery() {
  const location = useLocation();
  return new URLSearchParams(location.search);
}

function ContactInner() {
  const query = useQuery();
  const initialDataset = query.get('dataset') || '';

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [organization, setOrganization] = useState('');
  const [datasetInterest, setDatasetInterest] = useState(initialDataset);
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    const subject = encodeURIComponent('Dataset / subscription request');
    const body = encodeURIComponent(
      [
        `Name: ${name}`,
        `Email: ${email}`,
        `Organization: ${organization}`,
        `Dataset of interest: ${datasetInterest}`,
        '',
        'Message:',
        message,
      ].join('\n')
    );

    // Update this email address if you prefer a different one
    window.location.href = `mailto:hi@conversation-intelligence.com?subject=${subject}&body=${body}`;
  };

  return (
    <Box sx={{ padding: 3, maxWidth: 800, mx: 'auto' }}>
      <Typography variant="h4" sx={{ mb: 1 }}>
        Talk to us about datasets
      </Typography>
      <Typography variant="body1" sx={{ color: 'text.secondary', mb: 3 }}>
        Tell us what you’re trying to learn, and we’ll help you get access to the right interview datasets.
      </Typography>

      <Paper sx={{ p: 3 }}>
        <form onSubmit={handleSubmit}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              label="Your name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              fullWidth
              required
            />
            <TextField
              label="Your email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              fullWidth
              required
            />
            <TextField
              label="Organization"
              value={organization}
              onChange={(e) => setOrganization(e.target.value)}
              fullWidth
            />
            <TextField
              label="Dataset you’re interested in"
              value={datasetInterest}
              onChange={(e) => setDatasetInterest(e.target.value)}
              fullWidth
              placeholder="e.g. Short term rentals, PocketPennies users…"
            />
            <TextField
              label="What are you trying to learn?"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              fullWidth
              multiline
              minRows={4}
            />

            <Box sx={{ mt: 2 }}>
              <Button type="submit" variant="contained">
                Send email
              </Button>
            </Box>
          </Box>
        </form>
      </Paper>

      <Box sx={{ mt: 3 }}>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          Prefer to reach out directly? Email us at{' '}
          <a href="mailto:hi@conversation-intelligence.com">
            hi@conversation-intelligence.com
          </a>
          .
        </Typography>
      </Box>
    </Box>
  );
}

export default function Contact() {
  // This route is public so marketing CTAs can reach it. The app NavBar links
  // to Dashboard/Interviews, which are meaningless (and login-gated) for a
  // logged-out prospect — only show it to signed-in users.
  const isSignedIn = Boolean(localStorage.getItem('access_token'));

  return (
    <ThemeProvider theme={theme}>
      {isSignedIn && <NavBar />}
      <ContactInner />
    </ThemeProvider>
  );
}
